import React from 'react'
import FooterText from '../ui/atoms/FooterText'
import { Brand } from './typings'

const athome: Brand = {
  clientInfo: {
    displayName: 'At Home',
    accountNumberLengths: [16],
    footerDisplay: 'athome.com',
    footerLink: 'https://www.athome.com',
    applicationUrl:
      'https://apply.syf.com/eapply/eapply.action?clientCode=ATHOME',
    dsecApigeeClientId: {
      development: 'GayaBca8qACVu2GPqAmHyVezgFGySTfF',
      production: 'UsvVzjgF80FBhLDyUJwGBLs5AO3Wu8Wy'
    },
    persistApigeeClientId: { development: '', production: '' },
    setpayApigeeClientId: {
      development: '',
      production: ''
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your At Home credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito At Home en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    languages: ['en'],
    vanityUrl: 'athome.com',
    hostname: 'athome.syf.com',
    linkingRedirect: '',
    ivaKey: 'aebf16f9-4005-4f5c-9153-298c1ef1c5a3',
    hasMss: true,
    hasCpl: false,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: false,
    footerContent: {
      en: (
        <>
          <FooterText>
            *Rewards: Purchases subject to credit approval. At Home Insider
            Perks® credit cardholders are eligible to earn rewards on purchases
            made with their At Home Insider Perks® Credit Card or At Home
            Insider Perks® Mastercard account. Rewards apply to net card
            purchases (purchases minus returns and adjustments). Cardholders
            will earn five (5) points for each dollar ($1) of net card purchases
            made in At Home store locations or{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.athome.com/"
            >
              www.athome.com.
            </a>{' '}
            At Home Insider Perks® Mastercard cardholders will earn three (3)
            points for every dollar ($1) spent in net card purchases made at any
            other participating merchant or services where Mastercard is
            accepted. Points will be deducted for any returns or credits made on
            the cardholder account. Points will appear on your monthly
            statement. A $5 reward certificate (“Reward Certificate”) will be
            issued for every 500 points earned. Reward Certificates may be
            issued in $5, $10, $15 or $20 denominations. A cardholder can
            receive up to four (4) Reward Certificates per statement month.
            Reward Certificates are valid for 90 days from issue date. See the{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.synchronycredit.com/essimages/cs/groups/ess_webasset/dualcard/@athome/en/html/ess013240.html"
            >
              At Home Insider Perks® Credit Card and At Home Insider Perks®
              Mastercard Rewards Program Terms
            </a>{' '}
            for complete details.
          </FooterText>
          <FooterText>
            ** Subject to credit approval. Minimum monthly payments required.
            See store for details. We reserve the right to discontinue or alter
            the terms of this offer at any time.
          </FooterText>
          <FooterText>
            Your At Home Insider Perks® Mastercard or At Home Insider Perks®
            Credit Card is issued by Synchrony Bank. The Synchrony Bank Privacy
            Policy governs the use of the At Home Insider Perks® Mastercard or
            At Home Insider Perks® Credit Card. The use of this site is governed
            by the use of the Synchrony Bank Internet Privacy Policy, which is
            different from the privacy policy of At Home.
          </FooterText>
          <FooterText>
            The At Home Insider Perks® Mastercard is issued by Synchrony Bank
            pursuant to a license by Mastercard International Incorporated.
            Mastercard and the circles design are registered trademarks of
            Mastercard International Incorporated.
          </FooterText>
          <FooterText>
            The Contactless Indicator mark, consisting of four graduating arcs,
            is a trademark owned by and used with permission of EMVCo, LLC.
          </FooterText>
        </>
      ),
      es: ''
    },
    phoneNumbers: {
      loan: '',
      plcc: '1-855-474-7024',
      dualcard: '1-855-411-4729',
      fraud: '1-855-411-4729',
      customerService: '1-855-411-4729'
    },
    iOSAppId: '',
    androidApp: {
      id: '',
      author: '',
      title: '',
      image: ''
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/dualcard/@athome/en/html/ess011381.html',
      es: ''
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@athome/en/html/ess011404.html',
      es: ''
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@athome/en/html/ess011398.html',
      es: ''
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/generic/@athome/en/html/ess011402.html',
      es: ''
    },
    voice: {
      cardName: '',
      google: {
        termsAndConditionsLink: ''
      },
      alexa: {
        termsAndConditionsLink: ''
      }
    }
  },
  palette: {
    formBackground: '',
    field: {
      icon: '#333333',
      focus: '#34657F',
      label: ''
    },
    progressStepBar: {
      fill: '#333333',
      label: '#333333'
    },
    progressBar: {
      complete: '',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    button: {
      primary: {
        text: '#FFFFFF',
        hover: '#06243b'
      },
      secondary: {
        hover: '#cfdce5'
      },
      background: '#083354'
    },
    checkbox: {
      background: '#083354',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '#666666',
    bodyBackground: '#ffffff',
    iconBackground: '#CACACA',
    headerBackground: '#FFFFFF',
    modalBackground: '#FFFFFF',
    headerDivider: '#FFFFFF',
    footerDivider: '#FFFFFF',
    contrastingText: '#FFFFFF',
    bodyText: '#333333',
    languageSelector: '#ffffff',
    focus: '#003d50',
    link: '#083354',
    footer: {
      background: '#fcfcfc',
      text: '#333333',
      link: '#333333'
    }
  },
  images: {
    logo: {
      en: '/assets/athome/logo.png',
      es: '/assets/athome/logo.png'
    },
    hero: '/assets/athome/background.jpg',
    heroBgDesktop: '',
    heroBgMobile: '',
    mainPromo: {
      en: '/assets/athome/promo.png',
      es: '/assets/athome/promo.png'
    },
    voiceCplLogo: ''
  }
}

export default athome
